import React from "react";
import BackgroundImg from "../img/BackgroundNetImg.svg";
import Header from "./Header";

const Notifications = () => {
  return (
    <div
      style={{
        backgroundImage: `url(${BackgroundImg})`,
        backgroundPosition: "50% 0%",
      }}
    >
      <Header></Header>
      <div className="py-10 px-10 h-screen">
        <div className="flex justify-between">
          <span className="font-semibold text-2xl ">Notification</span>
          {/* <button className="bg-primary text-white px-6 font-semibold text-sm rounded-md">
            Remove All
          </button> */}
        </div>

        {/* <div className="mt-5 flex flex-col gap-4">
          <div
            className="flex justify-between border border-[#D9D9D9]  py-2 px-2 bg-white rounded"
            style={{ boxShadow: "0px 1px 4px 0px #00000040" }}
          >
            <span className="test-xs pb-10">Notification</span>
            <span className="text-[#8C8C8C] text-xs">
              1:22pm . 12 July 2024
            </span>
          </div>

          <div
            className="flex justify-between border py-2 px-2 bg-white rounded"
            style={{ boxShadow: "0px 1px 4px 0px #00000040" }}
          >
            <span className="test-xs pb-10">Notification</span>
            <span className="text-[#8C8C8C] text-xs">
              1:22pm . 12 July 2024
            </span>
          </div>

          <div
            className="flex justify-between border  py-2 px-2 bg-white rounded"
            style={{ boxShadow: "0px 1px 4px 0px #00000040" }}
          >
            <span className="test-xs pb-10">Notification</span>
            <span className="text-[#8C8C8C] text-xs">
              1:22pm . 12 July 2024
            </span>
          </div>
        </div> */}

        <div className="flex justify-start items-center mt-5">
          <span>No data..</span>
        </div>
        
      </div>
    </div>
  );
};

export default Notifications;
